export default {
  removePrompt(state, id) {
    delete state.queuePrompts[id];
  },
};
